import api from './api.services';
import axios from 'axios';

export const searchUserInfo = (contactType, options) => dispatch =>{
    let ServiceUrl;
    if (contactType === 'Instructor') {
        ServiceUrl = api.search_instructors
            .replace('{search-text}', options.searchTerm)
            .replace('{geo-id}', options.geoId)
            .replace('{unscrubbed}', options.unscrubbed)
        ;
    } else {
        ServiceUrl = api.search_users.replace('{user-role}', contactType).replace('{search-text}', options.searchTerm);
    }
    return axios.get(ServiceUrl);
};



// WEBPACK FOOTER //
// ./src/_thunks/identity.thunk.js